import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import {needAuth, noAuh} from "../../api/instance/Instance";


function SimmsSystemPasswordReset() {
    const navigate = useNavigate(); // 페이지 이동을 위한 useNavigate 사용

    async function resetPassword() {
        try {
            const response = await noAuh.get('/user/resetPassword');
            if(response.status === 200){
                // 200인 경우
                alert('비밀번호가 초기화되었습니다.');
                navigate('/');
            }else {
                // 200이 아닌 경우
                alert("비밀번호 초기화에 실패하였습니다. 관리자에게 문의해주세요");
                throw new Error("서버 연결 실패");
                navigate('/');
            }
        }
        catch (error){
            console.error('비밀번호 초기화 중 오류 발생:', error);
            alert('비밀번호 초기화에 실패했습니다.');
        }
    }

    useEffect(() => {
        // 컴포넌트가 마운트되자마자 API 호출

        resetPassword();
    }, []); // 빈 배열을 전달해 컴포넌트 마운트 시 한 번만 실행

    return (
        <div className={`m-auto w-[400px] mt-[200px]`}>
            <p className={`text-center text-[20px]`}>비밀번호 초기화 중...</p>
        </div>
    );
}

export default SimmsSystemPasswordReset;